<template>
  <div>
    <main-header/>
    <div class="aboutUs-bg">
      <nav-bar class="d-md-block d-none"/>
      <div class="container text-center">
        <div class=" mt-sm-0 mt-5">
          <h1 class="col-auto text-center border-bottom-title mb-6 primary-text">
            تماس با انتشارات شاهکار قلم
          </h1>
          <div class="row no-gutters mt-10 align-items-start">
            <div class="col-sm-3 col-12">
              <div><i class="fas fa-mobile-alt contactUs-icon"></i></div>
              <div class="mt-3"><a href="tel:09123342362" class="mt-2 black--text">{{ mobile }}</a>
              </div>
            </div>
            <div class="col-sm-6 col-12 my-sm-0 my-5">
              <div><i class="fas fa-map-marker-alt contactUs-icon"></i></div>
              <div class="mt-2">{{ address }}</div>
            </div>
            <div class="col-sm-3 col-12 ">
              <div><i class="fas fa-phone-square contactUs-icon"></i></div>
              <div class="mt-3"><a href="tel:02166401244" class="mt-2 black--text"> 02166401244</a>
              </div>
            </div>
            <div class="col-12">
              <div class="mt-10">
                <h3>شبکه های اجتماعی</h3>
              </div>
              <div class="col-5 mx-auto">
                <div class="row">
                  <div class="col">
                    <a href="https://wa.me/+989123342362" target="_blank">
                      <i class="fab fa-whatsapp socialMedia"></i>
                    </a>
                  </div>
                  <div class="col">
                    <a href="https://www.instagram.com/shahkareghalam" target="_blank">
                      <i class="fab fa-instagram socialMedia"></i>
                    </a>
                  </div>
                  <div class="col">
                    <a href="https://t.me/+989197830724" target="_blank">
                      <i class="fab fa-telegram-plane socialMedia"></i>
                    </a>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-12">
              <GmapMap
                  ref="mapRef"
                  :center="myCoordinates"
                  :options='{ fullscreenControl: false, mapTypeControl: false }'
                  :zoom="zoom"
                  style="height:360px"
              >
                <GmapMarker
                    v-for='(marker,index) in markers'
                    :key="index"
                    :animation="2"
                    :clickable="true"
                    :position="marker"
                    @click="center=marker"/>
              </GmapMap>
            </div>
            <div class="col-12 mt-5">
              <h3 class="text-center secondary-text h5">لینک های مسیریابی</h3>
              <div class="row">
                <div class="col-3 text-center">
                  <a :href="'https://www.google.com/maps/dir///'
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                     target="_blank">
                    <img alt="آدرس انتشارات شاهکار قلم"
                         class="img-fluid"
                         src="../assets/img/directions/google.png"
                         title="آدرس انتشارات شاهکار قلم"
                    />
                  </a>
                </div>
                <div class="col-3 text-center">
                  <a :href="'https://waze.com/ul?ll='
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                     target="_blank">
                    <img alt="آدرس انتشارات شاهکار قلم" class="img-fluid"
                         src="../assets/img/directions/waze.png"
                         title="آدرس انتشارات شاهکار قلم"
                    />
                  </a>
                </div>
                <div class="col-3 text-center">
                  <a :href="'https://neshan.org/maps/routing/car/destination/'
                  + myCoordinates.lat + ',' + myCoordinates.lng"
                     target="_blank">
                    <img alt="آدرس انتشارات شاهکار قلم" class="img-fluid"
                         src="../assets/img/directions/neshan.png"
                         title="آدرس انتشارات شاهکار قلم"
                    />
                  </a>
                </div>
                <div class="col-3 text-center">
                  <a :href="'https://balad.ir/directions/driving?destination='
                  + myCoordinates.lng + ',' + myCoordinates.lat"
                     target="_blank">
                    <img alt="آدرس انتشارات شاهکار قلم" class="img-fluid"
                         src="../assets/img/directions/balad.png"
                         title="آدرس انتشارات شاهکار قلم"
                    />
                  </a>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>

    </div>

    <Footer/>
    <navigation-drawer :drawer="drawer"/>

  </div>
</template>

<script>
import MainHeader from "./mainHeader";
import navBar from "./navBar";
import NavigationDrawer from "./navigationDrawer";
import Footer from "./Footer";

export default {
  name: "contactUs",
  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {Footer, NavigationDrawer, navBar, MainHeader},
  data: () => ({
    drawer: false,
    mobile: '09123342362',
    tel1: '021-33531060',
    tel2: '021-33531070',
    tel3: '021-33531080',
    address: 'تهران میدان اتریش خیابان بنفشه دهم مرکز تجاری باران طبقه همکف واحد 143',
    myCoordinates: {
      lat: 35.756860573317894,
      lng: 51.2424154360149
    },
    center: {
      lat: 35.756860573317894,
      lng: 51.2424154360149
    },
    zoom: 16,
    markers: [
      {
        lat: 35.756860573317894,
        lng: 51.2424154360149
      }
    ],
  })
}
</script>

<style scoped>

</style>